import React from 'react';
import { AppConfigurationContext } from '../useAppConfiguration';
function useBookingAppConfiguration() {
  const ctx = React.useContext(AppConfigurationContext);
  if (!ctx) {
    throw new Error('useBookingAppConfiguration must be used within a AppConfigurationContainer');
  }
  return ctx;
}
export { useBookingAppConfiguration };